import { render, staticRenderFns } from "./GuideFeatured.vue?vue&type=template&id=3f89ab16&scoped=true"
import script from "./GuideFeatured.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideFeatured.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideFeatured.vue?vue&type=style&index=0&id=3f89ab16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89ab16",
  null
  
)

export default component.exports